// src/components/grammar/FloatingProgressTracker.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X, LayoutGrid, AlertCircle, Bookmark, BarChart3 } from 'lucide-react';
import GrammarProgressTracker from './GrammarProgressTracker';

const FloatingProgressTracker = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');

  const handleIconClick = (tab) => {
    setActiveTab(tab);
    setIsOpen(true);
  };

  const icons = [
    { name: 'overview', icon: <LayoutGrid size={24} />, label: 'Overview' },
    { name: 'mistakes', icon: <AlertCircle size={24} />, label: 'Mistakes' },
    { name: 'bookmarks', icon: <Bookmark size={24} />, label: 'Bookmarks' },
    { name: 'statistics', icon: <BarChart3 size={24} />, label: 'Statistics' },
  ];

  return (
    <>
      {/* 1. Collapsed View: Floating Icon Bar */}
      <div className="fixed top-1/2 right-0 -translate-y-1/2 z-40">
        <div className="bg-white rounded-l-lg shadow-lg border border-r-0 border-gray-200 flex flex-col items-center space-y-2 p-2">
          {icons.map((item) => (
            <button
              key={item.name}
              onClick={() => handleIconClick(item.name)}
              className="p-2 text-gray-600 hover:bg-blue-50 hover:text-blue-600 rounded-md transition-colors group relative"
              aria-label={item.label}
            >
              {item.icon}
              <span className="absolute right-full mr-2 px-2 py-1 bg-gray-800 text-white text-xs rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                {item.label}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Overlay for when the panel is open */}
      {isOpen && (
        <div
  onClick={() => setIsOpen(false)}
  className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 animate-fade-in-fast"
/>
      )}

      {/* 2. Expanded View: The Slide-Out Panel */}
      <div
        className={`fixed top-0 right-0 h-full w-[450px] max-w-full bg-gray-50 shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="h-full flex flex-col">
          {/* Panel Header */}
          <div className="flex justify-between items-center p-4 border-b bg-white">
            <h2 className="text-xl font-bold text-gray-800">Your Progress</h2>
            <button
              onClick={() => setIsOpen(false)}
              className="p-2 text-gray-500 hover:bg-gray-100 rounded-full"
            >
              <X size={20} />
            </button>
          </div>

          {/* Panel Content: Your existing GrammarProgressTracker */}
          <div className="overflow-y-auto flex-grow">
  <GrammarProgressTracker
    {...props}
    initialTab={activeTab}
    showTabs={false}
    onReviewMistakes={(mistake) => {
  setTimeout(() => setIsOpen(false), 100);  // 100ms delay
  if (props.onReviewMistakes) {
    props.onReviewMistakes(mistake);
  }
}}
    onReviewBookmark={(bookmark) => {
      setIsOpen(false);  // Close the panel
      if (props.onReviewBookmark) {
        props.onReviewBookmark(bookmark);
      }
    }}
  />
</div>
        </div>
      </div>
    </>
  );
};

export default FloatingProgressTracker;